export default {"src":"/org/_next/static/media/calendar.aa5de77b.svg","height":14,"width":13,"blurWidth":0,"blurHeight":0};